import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "E:/workspaces/shop-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * 认证表单
 * @author Spark
 */
import { mapMutations } from 'vuex';
import { SET_NAV_TITLE } from '$mutations';
import api from 'api/user';
export default {
  name: 'page-authentication-form',
  data: function data() {
    return {
      model: {},
      loading: false
    };
  },
  computed: {
    applyRole: function applyRole() {
      return this.$route.params['applyRole'];
    }
  },
  methods: _objectSpread(_objectSpread({}, mapMutations([SET_NAV_TITLE])), {}, {
    validateForm: function validateForm() {
      return this.$refs.form.validateForm();
    },

    /**
     * 保存表单
     */
    submit: function submit() {
      var _this = this;

      var vm = this;
      this.validateForm().then(function () {
        var apiMethod;

        switch (_this.applyRole.name) {
          case 'putong':
            apiMethod = 'applyAuthOrdinary';
            break;

          case 'gongxiang-geren':
            apiMethod = 'applyAuthPersonalSalesman';
            break;

          case 'disanfang':
            apiMethod = 'applyAuthDisanfang';
            break;

          case 'gongxiang-qiye':
            apiMethod = 'applyAuthPersonalEnterprise';
            break;
        }

        if (apiMethod != null) {
          vm.loading = true;
          api[apiMethod](_this.model).then(function (res) {
            if (res.type === 'SUCCESS') {
              vm.$router.push('/authentication');
            } else {
              _this.$toast('提交失败，请重试');
            }
          }).always(function () {
            vm.loading = false;
          });
        }
      });
    }
  }),
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.SET_NAV_TITLE(vm.applyRole.title);
    });
  },
  components: {
    'module-putong': function modulePutong() {
      return import("./module/putong.vue");
    },
    'module-gongxiang-geren': function moduleGongxiangGeren() {
      return import("./module/gongxiang-geren.vue");
    },
    'module-gongxiang-qiye': function moduleGongxiangQiye() {
      return import("./module/gongxiang-qiye.vue");
    },
    'module-daixiao': function moduleDaixiao() {
      return import("./module/daixiao.vue");
    },
    'module-disanfang': function moduleDisanfang() {
      return import("./module/disanfang.vue");
    }
  }
};